import request from '@/utils/request';

// 营销活动列表
export function promotionList(params) {
  return request({
    url: '/promotion/v1',
    params
  })
}

// 营销活动新增
export function promotionAdd(data) {
  return request(
    {
      url: '/promotion/v1',
      method: 'POST',
      data
    }
  )
}

// 营销活动校验
export function promotionCheck(data) {
  return request({
    url: '/promotion/check/v1',
    method: 'POST',
    data
  })
}

// 店铺列表
export function shopListApi(params) {
  return request({
    url: '/shop/v1',
    params,
  })
}


// 获取全部组织
export function orgListApi(params) {
  return request({
    url: `/mct_org/v1`,
    params
  })
}

// 商品库商品
export function goodsListApi(params) {
  return request({
    url: '/goods/v1',
    params
  })
}
// 在售商品
export function searchGoodsListApi(params) {
  return request({
    url: '/promotion/shop/goods/v1',
    params
  })
}

// 卡券管理列表
export function couponManagerList(params) {
  return request({
    url: '/mct_coupon/v1',
    params
  })
}

// 设置卡券状态
export function couponEnabled(id, data) {
  return request({
    url: `/mct_coupon/${id}/v1`,
    method: 'PUT',
    data
  })
}


// 新增卡券
export function couponAddApi(data) {
  return request(
    {
      url: '/mct_coupon/v1',
      method: 'POST',
      data
    }
  )
}


// 营销活动启用禁用
export function promotionStatus(id, data) {
  return request({
    url: `/promotion/status/${id}/v1`,
    method: 'PUT',
    data
  })
}

// 营销活动详情
export function promotionDetail(id) {
  return request({
    url: `/promotion/${id}/v1`,
    method: 'GET'
  })
}


// 营销活动组织列表
export function promotionOrg(id, params) {
  return request({
    url: `/promotion/org/${id}/v1`,
    params
  })
}

// 营销活动店铺列表
export function promotionShop(id, params) {
  return request({
    url: `/promotion/shop/${id}/v1`,
    params
  })
}

// 营销活动商品列表
export function promotionGoods(id, params) {
  return request({
    url: `/promotion/goods/${id}/v1`,
    params
  })
}

// 营销活动人群列表
export function promotionUser(id, params) {
  return request({
    url: `/promotion/tag/${id}/v1`,
    params
  })
}


// 根据id查询卡券详情
export function couponListDetailApi(id) {
  return request({
    url: `/mct_coupon/${id}/v1`
  })
}


// 卡券详情店铺列表
export function getCouponShopListApi(id) {
  return request({
    url: `/mct_coupon/shop/${id}/v1`
  })
}

// 卡券详情商品列表
export function getCouponGoodsListApi(id) {
  return request({
    url: `/mct_coupon/goods/${id}/v1`
  })
}

// 设置卡券状态
export function couponEnabledApi(id, data) {
  return request({
    url: `/mct_coupon/${id}/v1`,
    method: 'PUT',
    data
  })
}

// 卡卷发放
export function couponSendStampsApi(data) {
  return request(
    {
      url: `/mct_coupon/v1`,
      method: 'PUT',
      data
    }
  )
}

// 会员类别列表
export function memberListApi() {
  return request({
    url: `/mct_user_tag/v1`
  })
}

//店铺导入
export function shopImportApi(data) {
  return request({
    url: `/import_excel/shop_file_import/v1`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data', // 针对文件上传的请求头
    },
    data
  })
}